import { useEffect } from "react";

const TableErrorBoundaryFallback = () => {
    useEffect(() => {
        window.location.reload();
    }, []);

    return null;
};

export default TableErrorBoundaryFallback;
